export default {
    colors: {
      primary: '#F5F5DC',
      background: '#141414',
      shape: `#4d4d4d`,
      title: `#FFFFFF`,
      text: `#FFFFFF`,
      components: {
        blockquote: {
          background: `#feebc8`,
          text: `#2d3748`,
        },
      },
    },
  };
  